// extracted by mini-css-extract-plugin
module.exports = {"container":"User_container__33gPg","userInfoContainer":"User_userInfoContainer__1PTUz"};